export function parseApiError(error, fallback = 'An error occurred') {
    if (!error?.response?.data) {
        return error?.message || fallback;
    }

    const data = error.response.data;

    if (data.error) {
        return data.error;
    }

    if (data.message) {
        return data.message;
    }

    if (data.errors) {
        return Object.values(data.errors).flat().join('\n');
    }

    return fallback;
}
